import ReactDOM from 'react-dom/client';
import App from './App';
import AppDev from './app/App';

import './style.less';

// eslint-disable-next-line import/no-unresolved
import '@mairistem/styles';

ReactDOM.createRoot(document.getElementById('globalContainer'))
  .render(
    process.env.NODE_ENV === 'development' ? <AppDev /> : <App />,
  );
